import type { GetProductsResponse } from "../../types/product";
import { AppError } from "../../../shared/utils/error-handler";
import type { CompanyRouterRepository } from "../../repositories/company/company-router-repository";
import type { RouterEntity } from "../../types/router";

export class CompanyRouterUsecase {
  constructor(private companyRouterRepository: CompanyRouterRepository) {}

  async getRouters(companyId: number): Promise<RouterEntity[]> {
    try {
      return await this.companyRouterRepository.getRouters(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "업체 라우터를 불러오지 못했습니다.",
        "ROUTER_GET_FAILED",
        error,
      );
    }
  }
}
